export default "__VITE_ASSET__hD9o$0aC__"